export const COOKIE_CATEGORY = Object.freeze({
    NECESSARY: 'necessary',
    PERFORMANCE: 'performance',
    FUNCTIONALITY: 'functionality',
    MARKETING: 'marketing',
});

export const NON_ESSENTIAL_COOKIES = Object.freeze([
    COOKIE_CATEGORY.PERFORMANCE,
    COOKIE_CATEGORY.FUNCTIONALITY,
    COOKIE_CATEGORY.MARKETING,
]);

export const buildCookieConsentMap = (categories, value = false) =>
    categories.reduce((acc, category) => {
        acc[category] = value;
        return acc;
    }, {});
